import React, { useCallback, useEffect, useState } from 'react';
import { Box, ButtonBase, Dialog, IconButton, InputBase, makeStyles, RadioGroup, Typography } from '@material-ui/core';
import moment from 'moment';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import _ from 'lodash';
import { KeyboardDateTimePicker } from '@material-ui/pickers';
import { CloseIcon, DateIcon, DropDownIcon, PostDayIcon, TagIcon } from '../../../../../components/Icon';
import DropCheckBox from '../../DropCheckBox';
import f from '../../../../../comm/fontStyles';
import BottomPop from '../BottomPops';
import { i18n } from '../../../../../language';
import { AutoCompleteInput, DragDropUpload } from '../../../../../components';
import { ehandoverAPI, systemAPI } from '../../../../../apis';
import { hospitalWardListFunc } from '../../../../../utils/hospitalWardList';
import PostDayPop from '../PostDayPop';
import { checkSubmitData } from '../../../../../utils/check';
import { classNames, revokePreviewUrl } from '../../../../../utils';
import Tag from '../../../../EHandover/components/CreateNote/tag';
import { Checkbox } from '../../../../DutyAssign/components/Attendance/Setting';
import UpLoadCom from '../UpLoadCom';
import { alertMsg } from '../../../../../apis/commlogic';
import useForward from '../../../../../utils/useForward';
import AutoCompleteCheckbox from '../../../../../components/AutoCompleteCheckbox';
import CustomRadio from '../../../../../components/Radio';
import { baseCssBooking } from '../../../../BedStatus/components/PopWindows/baseCss';
import useUploadFile, { ACCEPT_FILE_TYPES } from '../../../../../utils/hooks/useUploadFile';

const styles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      overflowY: 'hidden',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '43.75rem',
    borderRadius: '0.625rem',
    boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
    overflow: 'auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1.875rem 1.875rem 1.563rem 1.563rem',
  },
  title: {
    ...f.NB_b_1d5rem,
    color: '#2e4469',
  },
  iconButton: {
    marginRight: '-12px',
  },
  closeIcon: {
    width: '1.375rem',
    height: '1.375rem',
    color: '#538fff',
  },
  main: {
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 1.875rem 0 1.563rem ',
  },
  inputLabel: {
    ...f.NM_500_0d875rem,
    color: '#7d86a9',
    height: '2.5rem',
    display: 'flex',
    alignItems: 'center',
  },
  inputBase: {
    ...f.NM_500_1rem,
    padding: '1rem 0.813rem 1rem 1.25rem',
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    color: '#2e4469',
    width: '100%',
    lineHeight: '1.5rem',
  },
  inputBaseMulti: {
    ...f.NM_500_1rem,
    padding: '1rem 0.813rem 1rem 1.25rem',
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    color: '#2e4469',
    lineHeight: '1.5rem',
    width: '100%',
  },
  footer: {
    height: '5.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 -1px 0 0 #e4e7eb',
  },
  cancelBtn: {
    ...f.NM_500_1rem,
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    background: '#f5faff',
    border: 'solid 1.5px #4c93ff',
    color: '#538fff',
  },
  sendBox: {
    display: 'flex',
    alignItems: 'center',
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    background: '#4c93ff',
  },
  sendBtn: {
    ...f.NM_500_1rem,
    height: '3rem',
    color: '#fff',
    flex: '1',
  },
  selectBtn: {
    height: '3rem',
    borderLeft: '0.063rem solid #2862ba',
  },
  dropDownIcon: {
    width: '1rem',
    height: '1rem',
    color: '#fff',
    marginRight: '1rem',
    margin: '0 0.688rem',
  },
  popItemIcon: {
    width: '1.25rem',
    height: '1.25rem',
    color: '#538fff',
  },
  popItemText: {
    ...f.NM_500_0d875rem,
    color: '#2e4469',
    marginLeft: '1rem',
  },
  popItemBtn: {
    display: 'flex',
    padding: '0.8rem 1.25rem',
  },
  labelError: {
    color: '#f44336',
  },
  inputError: {
    border: '1px solid #f44336',
  },
  errorMsg: {
    margin: '3px 0 0 0',
    color: '#f44336',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
  tagIcon: {
    fontSize: '1.375rem',
    color: '#7d86a9',
    margin: '0.563rem 0 1rem',
  },
  selectWard: {
    width: '14.063rem',
  },
  pinLabel: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    color: theme.palette.font.main,
    marginLeft: '0.25rem',
  },
  datepicker: {
    '& *': {
      padding: '0',
      margin: '0',
      border: '0',
    },
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      color: '#2e4469',
      height: '3.5rem',
      lineHeight: '3.5rem',
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      borderRadius: '0.625rem',
      border: 'solid 1px #e4e7eb',
      backgroundColor: '#fff',
      padding: '0 1.25rem',
      fontSize: '1rem',
    },
    '& .MuiInputBase-input': {
      height: '3.5rem',
      lineHeight: '3.5rem',
    },
    '& :focus': {
      backgroundColor: 'unset',
    },
    '& :before': {
      content: 'none',
    },
    ':before': {
      content: 'none !important',
    },
    '& :after': {
      content: 'none',
    },
  },
  keyboardDatePicker: {
    paddingRight: '0',
  },
  disabledStyle: {
    '& .MuiInputBase-root': {
      backgroundColor: '#f5f5f5',
    },
  },
}));

const P = {
  from: 'notificationFrom',
  title: 'notificationTitle',
  description: 'notificationDesc',
  selects: 'wardIds',
  postDat: 'postDay',
  type: 'category',
  tags: 'tags',
  pin: 'isPin',
  fileIds: 'fileIds',
  roomType: 'roomType',
  pinExpiryDate: 'pinExpiryDate',
  isManualUnpin: 'isManualUnpin',
};

export default function NewNotificationPop({ open, closePop, sendHandle, refreshNotificationTotal }) {
  const classes = styles();
  const baseClasses = baseCssBooking();
  const [tagList, setTagList] = useState([]);
  const [tag, setTag] = useState();
  const loginInfo = useSelector((state) => state.loginInfo);
  const [warn, setWarn] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const roomTypeList = useForward(true);
  const [fileTypeWarn, setFileTypeWarn] = useState([]);
  const [roomTypeOpen, setRoomTypeOpen] = useState(false);
  const { selectFile, imgList, setImgList, fileList, setFileList } = useUploadFile();

  useEffect(() => {
    if (alertOpen) {
      alertMsg(
        fileTypeWarn.length > 0
          ? i18n.t('EHANDOVER_FILE_TYPE_WARN', {
              text: ACCEPT_FILE_TYPES.map((v) => {
                return `"${v.replace('.', '')}"`;
              }).join(','),
            })
          : i18n.t('EHANDOVER_FILE_WARN', { value: warn.toString() }),
        'notify',
        'warning'
      );
      setWarn([]);
      setAlertOpen(false);
    }
  }, [alertOpen]);

  // get tag list API
  const getTagListAPI = async () => {
    try {
      const { result } = await ehandoverAPI.getHspTag();
      setTagList(
        _.map(result, (item) => {
          return {
            text: item.tagDesc,
            value: item.id,
          };
        })
      );
    } catch (error) {
      console.log('-----Get Tag List error----->', error);
    }
  };

  // upload file API
  const postFileAPI = async (fileDesc, fileName, fileSize, fileType, mineType) => {
    try {
      const { result } = await systemAPI.postNotificationFile({ fileDesc, fileName, fileSize, fileType, mineType });
      return result;
    } catch (error) {
      console.log('-----Upload File error----->', error);
    }
  };

  // delete file API
  const deleteFileAPI = async (fileIds, callback) => {
    try {
      await systemAPI.deleteNotificationFile({ fileIds });
      callback();
    } catch (error) {
      console.log('-----Delete File error----->', error);
    }
  };

  const [errorMsg, setErrorMsg] = useState(null);
  const schema = {
    [P.from]: Yup.string()
      .max(255, i18n.t('NOTIFICATION_MAX_CHARACTERSN', { value: 255 }))
      .required(i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('NOTIFICATION_From') })),
    [P.title]: Yup.string()
      .max(200, i18n.t('NOTIFICATION_MAX_CHARACTERSN', { value: 200 }))
      .required(i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('NOTIFICATION_Title') })),
    [P.description]: Yup.string().required(
      i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('NOTIFICATION_DESCRIPTION') })
    ),
    [P.selects]: Yup.array().min(1, i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('NOTIFICATION_WARD') })),
    [P.type]: Yup.string().required(i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('NOTIFICATION_TYPE') })),
    [P.roomType]: Yup.array().min(1, i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('NOTIFICATION_GROUP') })),
    pinExpiryDate: Yup.date()
      .nullable()
      .when('isManualUnpin', {
        is: (val) => !val,
        then: () => {
          return Yup.date()
            .required(i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_DATE') }))
            .min(moment().add(1, 'minutes'), '')
            .typeError(i18n.t('BEDSTATUS_INVALID_DATE_FORMAT'));
        },
      }),
  };

  const postDateSchema = {
    [P.postDat]: Yup.date().min(
      moment(moment().add(1, 'h').format('yyyy-MM-DD HH:00:00')),
      i18n.t('NOTIFICATION_POSTDAY_VERIFY', { value: moment().format('YYYY-MM-DD HH:00:00') })
    ),
  };

  const [InputValues, setInputValues] = useState({
    [P.from]: loginInfo.displayName,
    [P.title]: '',
    [P.description]: '',
    [P.selects]: [],
    [P.type]: 'NOTIFICATION',
    [P.tags]: [],
    [P.pin]: false,
    [P.roomType]: [],
    [P.isManualUnpin]: false,
    [P.pinExpiryDate]: moment().add(7, 'days'),
  });
  const [isAllSelect, setIsAllSelect] = useState(false);

  const changeHandle = (type, key) => {
    return (event) => {
      switch (type) {
        case 'text':
          handleTextChange(key, event);
          break;
        case 'select':
        case 'date':
          handleSelectOrDateChange(key, event);
          break;
        case 'allSelect':
          handleAllSelectChange(key, event);
          break;
        case 'tagSelect':
          handleTagSelectChange(key, event);
          break;
        case 'removeTag':
          handleRemoveTagChange(key, event);
          break;
        case 'roomType':
          handleRoomTypeChange(key, event);
          break;
        default:
          break;
      }
    };
  };

  const handleTextChange = (key, event) => {
    setInputValues({ ...InputValues, [key]: event.target.value });
  };

  const handleSelectOrDateChange = (key, event) => {
    setInputValues({ ...InputValues, [key]: event });
  };

  const handleAllSelectChange = (key, event) => {
    if (event) {
      setInputValues({ ...InputValues, [key]: WardItemList.map((item) => item.value) });
    } else {
      setInputValues({ ...InputValues, [key]: [] });
    }
  };

  const handleTagSelectChange = (key, event) => {
    if (!event || !_.isNumber(event)) return;

    setTag(event);
    if (!InputValues[key].some((item) => item === event)) {
      setInputValues((preData) => ({
        ...preData,
        [key]: [...preData[key], event],
      }));
    }
  };

  const handleRemoveTagChange = (key, event) => {
    setInputValues((preData) => ({
      ...preData,
      [key]: _.filter(preData[key], (item) => item !== event),
    }));
  };

  const handleRoomTypeChange = (key, event) => {
    setInputValues((preData) => {
      if (preData[key].some((item) => item.value === 6)) {
        // 已經是"Not to send"
        (async () => {
          await focusCheck(P.roomType)(_.filter(event, (item) => item.value !== 6));
        })();
        return {
          ...preData,
          [key]: _.filter(event, (item) => item.value !== 6),
        };
      } else if (_.some(event, (item) => item.value === 6)) {
        // 选择了"Not to send"
        setRoomTypeOpen(false);
        (async () => {
          await focusCheck(P.roomType)([_.find(event, (item) => item.value === 6)]);
        })();
        return {
          ...preData,
          [key]: [_.find(event, (item) => item.value === 6)],
        };
      } else {
        (async () => {
          await focusCheck(P.roomType)(event);
        })();
        return {
          ...preData,
          [key]: event,
        };
      }
    });
  };

  useEffect(() => {
    if (Array.isArray(InputValues[P.selects])) {
      if (InputValues[P.selects].length >= WardItemList?.length) {
        setIsAllSelect(true);
      } else {
        setIsAllSelect(false);
      }
    }
  }, [InputValues[P.selects]]);

  const [anchorEl, setAnchorEl] = useState(null);
  const openPopHandle = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const closePopHandle = () => {
    setAnchorEl(null);
  };

  const sendClick = async ({ postDate, callback }) => {
    try {
      await checkSubmitData(Yup.object().shape(schema), InputValues);
      setErrorMsg(null);
      const tempFiles = [...imgList, ...fileList];
      const params = {
        ...InputValues,
        [P.tags]: InputValues[P.tags].length === 0 ? null : InputValues[P.tags],
        [P.postDat]: postDate ? moment(postDate).format('yyyy-MM-DD HH:00:00') : moment().format('yyyy-MM-DD HH:mm:ss'),
        [P.pin]: InputValues[P.pin] ? '1' : '0',
        [P.fileIds]: _.map(tempFiles, (item) => {
          return item.id;
        }),
        [P.roomType]: _.map(InputValues[P.roomType], (item) => item.value),
        [P.isManualUnpin]: InputValues[P.isManualUnpin] ? 'Y' : 'N',
        [P.pinExpiryDate]: InputValues[P.isManualUnpin]
          ? null
          : InputValues[P.pinExpiryDate].format('yyyy-MM-DD HH:00:00'),
      };
      sendHandle && (await sendHandle(params));
      if (typeof callback === 'function') {
        callback();
      }
      revokePreviewUrl(imgList);
      refreshNotificationTotal();
    } catch (err) {
      setErrorMsg(err);
    }
  };

  const [WardItemList, setWardItemList] = useState(null);
  const getSysWardItemList = async () => {
    const { result } = await systemAPI.getSysWardItemList({
      userId: loginInfo.userId,
      corpId: loginInfo.corpID,
      hospId: loginInfo.hospitalId,
    });
    setWardItemList(hospitalWardListFunc.getAllWardFormat(result));
  };
  useEffect(() => {
    (async () => {
      await getSysWardItemList();
    })();
    (async () => {
      await getTagListAPI();
    })();
  }, []);

  const [isPostDayPop, setIsPostDayPop] = useState(false);
  const closePostDayPop = () => {
    setIsPostDayPop(false);
    setErrorMsg({ [P.postDat]: null });
  };
  const showPostDayPop = async () => {
    try {
      await checkSubmitData(Yup.object().shape(schema), InputValues);
      setErrorMsg(null);
      closePopHandle();
      setIsPostDayPop(true);
    } catch (error) {
      setErrorMsg(error);
    }
  };

  const getCheckLableClasses = (key) => {
    return errorMsg?.[key] ? classNames(classes.inputLabel, classes.labelError) : classes.inputLabel;
  };

  const getCheckInputClasses = (key, className) => {
    return errorMsg?.[key] ? classNames(className, classes.inputError) : className;
  };

  const focusCheck = (name) => {
    return async (props) => {
      try {
        await checkSubmitData(Yup.object().shape({ [name]: schema[name] }), { [name]: props ?? InputValues[name] });
        setErrorMsg({ ...errorMsg, [name]: null });
      } catch (e) {
        setErrorMsg({ ...errorMsg, ...e });
      }
    };
  };

  const dateVerify = async (value) => {
    try {
      await checkSubmitData(Yup.object().shape({ [P.postDat]: postDateSchema[P.postDat] }), { [P.postDat]: value });
      setErrorMsg({ ...errorMsg, [P.postDat]: null });
    } catch (e) {
      setErrorMsg({ ...errorMsg, ...e });
    }
  };

  const getIsPostDayPop = () => {
    return isPostDayPop || (errorMsg?.[P.postDat] && Object.values(errorMsg).length === 1);
  };

  const handleSelectFile = useCallback(
    (event) => selectFile(event?.target?.files, setWarn, setAlertOpen, setFileTypeWarn, postFileAPI),
    [setWarn, setAlertOpen]
  );

  const handleDeleteFile = (id, setData) => () => {
    const deleteFile = () => {
      setData((preData) => {
        return _.filter(preData, (item) => {
          return item.id !== id;
        });
      });
    };
    (async () => {
      await deleteFileAPI([id], deleteFile);
    })();
  };

  const handleChangeExpiryDate = async (event) => {
    try {
      await checkSubmitData(Yup.object().shape({ pinExpiryDate: schema['pinExpiryDate'] }), {
        pinExpiryDate: event,
      });
      setErrorMsg({ ...errorMsg, pinExpiryDate: null });
    } catch (e) {
      setErrorMsg({ ...errorMsg, ...e });
    }
    setInputValues((prev) => ({ ...prev, pinExpiryDate: event }));
  };

  const handleDragDropUpload = async (files) => {
    await selectFile(files, setWarn, setAlertOpen, setFileTypeWarn, postFileAPI);
  };

  return (
    <>
      {getIsPostDayPop() ? (
        <PostDayPop
          open={getIsPostDayPop()}
          id="Notification-PostDayPop-zzz"
          closePop={closePostDayPop}
          errorMsg={errorMsg?.[P.postDat]}
          error={Boolean(errorMsg?.[P.postDat])}
          verify={dateVerify}
          sendClick={sendClick}
        />
      ) : (
        ''
      )}
      <BottomPop anchorEl={anchorEl} closePop={closePopHandle} id="Notification-BottomPop-aal">
        <ButtonBase
          className={classes.popItemBtn}
          onClick={() => {
            (async () => {
              await showPostDayPop();
            })();
          }}
          id="Notification-ButtonBase-aam"
        >
          <PostDayIcon className={classes.popItemIcon} />
          <Typography className={classes.popItemText}>{i18n.t('NOTIFICATION_POST_DAY')} </Typography>
        </ButtonBase>
      </BottomPop>
      <Dialog
        open={open}
        id="Notification-Dialog-aao"
        maxWidth={false}
        className={classes.dialog}
        style={getIsPostDayPop() ? { visibility: 'hidden' } : ''}
      >
        <Box className={classes.root}>
          <header className={classes.header}>
            <Typography className={classes.title}>{i18n.t('NOTIFICATION_NEW_NOTIFICATION')}</Typography>
            <IconButton className={classes.iconButton} onClick={closePop} id="Notification-IconButton-aap">
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </header>
          <main className={classes.main}>
            <DragDropUpload onUpload={handleDragDropUpload}>
              <Box mb="1.875rem">
                <Typography className={getCheckLableClasses(P.from)} style={{ marginBottom: '0.625rem' }}>
                  {i18n.t('NOTIFICATION_From')}
                </Typography>
                <InputBase
                  multiline
                  rows={1}
                  rowsMax={2}
                  className={getCheckInputClasses(P.from, classes.inputBase)}
                  value={InputValues[P.from]}
                  onChange={changeHandle('text', P.from)}
                  id="Notification-InputBase-aaq"
                  placeholder={i18n.t('NOTIFICATION_PLEASE_FILL_IN_FROM')}
                  onBlur={() => {
                    (async () => {
                      await focusCheck(P.from)();
                    })();
                  }}
                />
                {errorMsg?.[P.from] ? <Typography className={classes.errorMsg}>{errorMsg[P.from]}</Typography> : ''}
              </Box>
              <Box mb="1.875rem">
                <Typography className={getCheckLableClasses(P.title)} style={{ marginBottom: '0.625rem' }}>
                  {i18n.t('NOTIFICATION_Title')}
                </Typography>
                <InputBase
                  multiline
                  rows={1}
                  rowsMax={2}
                  className={getCheckInputClasses(P.title, classes.inputBase)}
                  value={InputValues[P.title]}
                  onChange={changeHandle('text', P.title)}
                  id="Notification-InputBase-aaq"
                  placeholder={i18n.t('NOTIFICATION_PLEASE_FILL_IN_YOUR_TITLE')}
                  onBlur={() => {
                    (async () => {
                      await focusCheck(P.title)();
                    })();
                  }}
                />
                {errorMsg?.[P.title] ? <Typography className={classes.errorMsg}>{errorMsg[P.title]}</Typography> : ''}
              </Box>
              <Box mb="1.875rem">
                <Typography className={getCheckLableClasses(P.description)} style={{ marginBottom: '0.625rem' }}>
                  {i18n.t('NOTIFICATION_DESCRIPTION')}
                </Typography>
                <InputBase
                  multiline
                  rows={4}
                  rowsMax={14}
                  className={getCheckInputClasses(P.description, classes.inputBaseMulti)}
                  value={InputValues[P.description]}
                  onChange={changeHandle('text', P.description)}
                  id="Notification-InputBase-aar"
                  placeholder={i18n.t('NOTIFICATION_PLEASE_FILL_IN_YOUR_MESSAGE')}
                  onBlur={() => {
                    (async () => {
                      await focusCheck(P.description)();
                    })();
                  }}
                />
                {errorMsg?.[P.description] ? (
                  <Typography className={classes.errorMsg}>{errorMsg[P.description]}</Typography>
                ) : null}
              </Box>
              <Box style={{ marginBottom: '3.125rem' }}>
                <Box display="flex" flexDirection="column">
                  <Box display="flex">
                    <Typography className={classes.inputLabel} style={{ width: '5.126rem' }}>
                      {`${i18n.t('NOTIFICATION_SEND_TO')} :`}
                    </Typography>
                    <DropCheckBox
                      itemList={WardItemList}
                      value={InputValues[P.selects]}
                      onChange={changeHandle('select', P.selects)}
                      id="Notification-DropCheckBox-aas"
                      error={Boolean(errorMsg?.[P.selects])}
                      errorMsg={errorMsg?.[P.selects]}
                      onBlur={focusCheck(P.selects)}
                      isAllSelect={isAllSelect}
                      allSelectChange={changeHandle('allSelect', [P.selects])}
                      className={classes.selectWard}
                    />
                    <Box marginLeft="3.875rem">
                      <AutoCompleteCheckbox
                        id="Notification-Forward"
                        width="14.063rem"
                        height="2.5rem"
                        value={InputValues[P.roomType]}
                        itemList={roomTypeList}
                        placeholder={i18n.t('NOTIFICATION_FORWARD')}
                        onChange={changeHandle('roomType', P.roomType)}
                        error={Boolean(errorMsg?.[P.roomType])}
                        errorMsg={errorMsg?.[P.roomType]}
                        onBlur={focusCheck(P.roomType)}
                        allItem={false}
                        readOnly={true}
                        dropDownIcon={true}
                        open={roomTypeOpen}
                        onOpen={() => setRoomTypeOpen(true)}
                        onClose={() => setRoomTypeOpen(false)}
                      />
                    </Box>
                  </Box>
                </Box>
                <Box display="flex" mt="1.938rem" alignItems="center">
                  <Box width="5.126rem" pl="2.938rem">
                    <Checkbox
                      handleChange={() => {
                        setInputValues((preData) => {
                          return { ...preData, [P.pin]: !preData[P.pin] };
                        });
                      }}
                      id="Notification-Checkbox-aat"
                      check={InputValues[P.pin]}
                    />
                  </Box>
                  <div className={classes.pinLabel}>{i18n.t('NOTIFICATION_PIN')}</div>
                </Box>
                {InputValues[P.pin] && (
                  <Box pl="2.938rem" mt="1rem">
                    <RadioGroup col="true">
                      <CustomRadio
                        id="new-notification-unpin-later-radio"
                        name="mode"
                        label="Manual unpin later"
                        value={true}
                        checked={InputValues[P.isManualUnpin]}
                        onChange={() => {
                          setInputValues((prev) => {
                            return { ...prev, [P.isManualUnpin]: true, pinExpiryDate: null };
                          });
                        }}
                      />
                      <Box>
                        <CustomRadio
                          id="new-notification-pin-expiry-radio"
                          name="mode"
                          label="Pin with expiry date"
                          value={false}
                          checked={!InputValues[P.isManualUnpin]}
                          onChange={() => {
                            setInputValues((prev) => {
                              return {
                                ...prev,
                                [P.isManualUnpin]: false,
                                pinExpiryDate: moment().add(7, 'days'),
                              };
                            });
                          }}
                        />
                        <KeyboardDateTimePicker
                          id="notification-pinNote-pop-picker"
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          format="yyyy-MM-DD HH:00:00"
                          value={InputValues[P.pinExpiryDate]}
                          className={classNames(
                            classes.datepicker,
                            classes.keyboardDatePicker,
                            InputValues[P.isManualUnpin] && classes?.disabledStyle
                          )}
                          keyboardIcon={
                            <div className={classNames(baseClasses.dateIcon, classes.dateIcon)}>
                              <DateIcon />
                            </div>
                          }
                          disabled={InputValues[P.isManualUnpin]}
                          onChange={handleChangeExpiryDate}
                          InputAdornmentProps={{ position: 'end' }}
                          minDate={moment().add(1, 'minutes')}
                          strictCompareDates={true}
                          views={['date', 'hours']}
                          disableToolbar={true}
                          ampm={false}
                          style={{ width: '100%' }}
                        />
                      </Box>
                    </RadioGroup>
                  </Box>
                )}
                <Box display="flex" mt="1.938rem">
                  <Box width="5.126rem" pr="0.938rem" display="flex" justifyContent="flex-end">
                    <TagIcon className={classes.tagIcon} />
                  </Box>
                  <Box display="flex" flexWrap="wrap" maxWidth="84.9%" gridGap="0.5rem">
                    {InputValues[P.tags].map((tagsItem, index) => {
                      const tagItem = {
                        tag: tagList.find((item) => {
                          return item.value === tagsItem;
                        }).text,
                      };
                      return (
                        <Tag
                          tag={tagItem}
                          key={tagsItem}
                          onRemove={() => {
                            changeHandle('removeTag', P.tags)(tagsItem);
                          }}
                          id={`Notification-Tag-aau-${index}`}
                        />
                      );
                    })}
                    <AutoCompleteInput
                      width="14.063rem"
                      height="2.5rem"
                      itemList={tagList}
                      placeholder={i18n.t('EHANDOVER_CREATENOTE_TAG')}
                      value={tag}
                      onOpen={() => {
                        (async () => {
                          if (tagList.length === 0) {
                            await getTagListAPI();
                          }
                        })();
                      }}
                      id="Notification-AutoCompleteSelect-aav"
                      onChange={changeHandle('tagSelect', P.tags)}
                    />
                  </Box>
                </Box>
                <UpLoadCom
                  mt="3rem"
                  title={i18n.t('NOTIFICATION_NEW_PHOTO_TITLE')}
                  addTitle={i18n.t('NOTIFICATION_NEW_PHOTO_ADD_TITLE')}
                  placeholder={i18n.t('NOTIFICATION_NEW_PHOTO_PLACEHOLDER')}
                  setData={setImgList}
                  data={imgList}
                  handleSelectFile={handleSelectFile}
                  id="Notification-UpLoadCom-aaw"
                  handleDeleteFile={handleDeleteFile}
                  type="photo"
                  accept=".jpg,.png"
                  capture="camera"
                />
                <UpLoadCom
                  mt="3rem"
                  title={i18n.t('NOTIFICATION_NEW_FILE_TITLE')}
                  addTitle={i18n.t('NOTIFICATION_NEW_FILE_ADD_TITLE')}
                  placeholder={i18n.t('NOTIFICATION_NEW_FILE_PLACEHOLDER')}
                  setData={setFileList}
                  data={fileList}
                  handleSelectFile={handleSelectFile}
                  id="Notification-UpLoadCom-aax"
                  handleDeleteFile={handleDeleteFile}
                  type="file"
                  accept={ACCEPT_FILE_TYPES.join(',')}
                  capture={undefined}
                />
              </Box>
            </DragDropUpload>
          </main>
          <footer className={classes.footer}>
            <ButtonBase
              className={classes.cancelBtn}
              style={{ marginRight: '1.313rem' }}
              onClick={closePop}
              id="Notification-ButtonBase-aay"
            >
              {i18n.t('NOTIFICATION_CANCEL')}
            </ButtonBase>
            <div className={classes.sendBox}>
              <ButtonBase
                className={classes.sendBtn}
                onClick={(event) => {
                  (async () => {
                    await sendClick(event);
                  })();
                }}
                id="Notification-ButtonBase-aaz"
              >
                {i18n.t('NOTIFICATION_SEND')}
              </ButtonBase>
              <ButtonBase className={classes.selectBtn} onClick={openPopHandle} id="Notification-ButtonBase-aba">
                <DropDownIcon className={classes.dropDownIcon} />
              </ButtonBase>
            </div>
          </footer>
        </Box>
      </Dialog>
    </>
  );
}
